import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';

import { useStyletron } from 'baseui';
import AuthorizedRoute from '../../../permission/AuthorizedRoute';

import { SETTINGS_V2_RESOURCES, PAGE_NAMES, PERMISSIONS_MANAGEMENT_RESOURCES } from '../../../settingsV2Constant';
import PermissionsManagementHome from './PermissionsManagementHome';
import { URL, COMPONENT } from './helper';

const Dashboard: React.FC<{}> = () => {
	const [css] = useStyletron();
	return (
		<>
			<div className={css({ height: '100%', overflow: 'auto' })}>
				<Switch>
					<AuthorizedRoute
						exact
						configPageName={PAGE_NAMES.permissionsManagement}
						path={`/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.permissionsManagement}`}
						component={PermissionsManagementHome}
					/>
					{_map(_values(PERMISSIONS_MANAGEMENT_RESOURCES), (resourceName: string) => (
						<AuthorizedRoute
							key={resourceName}
							configPageName={PAGE_NAMES.permissionsManagement}
							configResourceName={resourceName}
							path={URL[resourceName]}
							component={COMPONENT[resourceName]}
						/>
					))}
					<Redirect to={`/${PAGE_NAMES.settingsV2}/${SETTINGS_V2_RESOURCES.permissionsManagement}`} />
				</Switch>
			</div>
		</>
	);
};

export default Dashboard;
